import React from "react";
import { Field } from "redux-form";
import styled from "@emotion/styled";

const Container = styled.div`
  display: grid;
  grid-template-columns: 34px 1fr;
  cursor: pointer;
  position: relative;
`;

const UseSpan = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.setColor};

  @media (max-width: 875px) {
    font-size: 13px;
  }
`;

const StyledCheckbox = ({
  handleAddressChange,
  setOpacity = 1,
  openToEdit = true,
  name,
  text,
  validate
}) => {
  return (
    <Field
      setOpacity={setOpacity}
      name={name}
      handleChange={() => {
        if (handleAddressChange) {
          handleAddressChange(false);
        }
      }}
      validate={validate ? validate : null}
      openToEdit={openToEdit}
      label={name}
      component={({ input, openToEdit, handleChange }) => (
        <Container className="checkbox-container">
          <div>
            <input
              name=""
              className={
                setOpacity === 1 ? "checkbox-input" : "checkbox-input-faded"
              }
              checked={input.value}
              type="checkbox"
              disabled={!openToEdit}
              onChange={f => f}
              onMouseDown={() => {
                input.onChange(!input.value);
                handleChange();
              }}
            />
            <span className="checkbox-fake-span" />
          </div>
          <UseSpan setColor={`rgba(119, 121, 132, ${setOpacity})`}>
            {text}
          </UseSpan>
        </Container>
      )}
    />
  );
};

export default StyledCheckbox;
